// extracted by mini-css-extract-plugin
export var colorSquare = "_j1-0";
export var danger = "_j1-5";
export var lightPink = "_j1-8";
export var neutralBlue = "_j1-7";
export var neutralYellow = "_j1-6";
export var normal = "_j1-1";
export var primary = "_j1-2";
export var primaryLight = "_j1-3";
export var solidBlack = "_j1-g";
export var solidGreen = "_j1-b";
export var solidLightBlue = "_j1-d";
export var solidNavy = "_j1-c";
export var solidOrange = "_j1-f";
export var solidPink = "_j1-e";
export var solidRed = "_j1-9";
export var solidYellow = "_j1-a";
export var success = "_j1-4";